import fetch from 'isomorphic-fetch';
import { browserHistory } from 'react-router';
import zxcvbn from 'zxcvbn';

const TOGGLE_TAC_CHECKBOX = 'TOGGLE_TAC_CHECKBOX';
const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
const GET_AZURE_PROVIDER_RELATIONSHIP = 'GET_AZURE_PROVIDER_RELATIONSHIP';
const RECEIVE_AZURE_PROVIDER_RELATIONSHIP = 'RECEIVE_AZURE_PROVIDER_RELATIONSHIP';
const TOGGLE_FS_LOADING = 'TOGGLE_FS_LOADING'; //This will toggle the visibility of a fullscreen Loading spinner
const FETCH_MONTH_TO_DATE = 'FETCH_MONTH_TO_DATE';
const CREATE_NEW_USER = 'CREATE_NEW_USER'; // Create new user
const FETCH_USERS_LIST = 'FETCH_USERS_LIST'; //List of users under current admin
const PENDING_USERS = 'PENDING_USERS';


//////////////////////
// Month to Date
//////////////////////

export function fetchMonthToDate ( payload ) {
	console.log( ' FYI fetchMonthToDate was dispatched! ');
	return function ( dispatch, getState ) {
		dispatch ( callFetchMonthToDateRed ({
			status: 'init',
			showLoading: true,
			data: {},
			hasFailed: false,
			...payload
		}));
		Sso.authorize()
			.then(function (authorization) {
				dispatch ( callFetchMonthToDateRed ( {
					status: 'fetching',
					showLoading: true,
					isFetching: true,
					...payload
				} ) );
				//for json-server ==> http://localhost:3693/currentBalance
				return fetch(`/accounts/${getState().getAzureProviderRelationshipRed.rootAccountAlias}/azure/currentBalance`, { // TODO! fix this as this is only to test the request (I didn't know the ned-point url
					data: "json",
					method: 'GET',
					headers: {
						Authorization: (`Bearer ${authorization.token}`)
					}
				})
					.then(response => {
						console.log('Month To Date json: ', response)
						if(!response.ok){//TODO: needs work
							alert('Not 200, needs implementation (out of scope) <- according to the .status code react appropriately..');
							dispatch(callFetchMonthToDateRed({
								status: 'failed',
								showLoading: false,
								isFetching: false,
								hasFailed: true,
								rootAccountAlias: authorization.rootAccountAlias,
								bearerToken: authorization.token,
								...payload
							}));
						}
						return response.json()})
					.then(json =>  // json is the meat of the response that we will pass to the component as data prop
						{
							dispatch(callFetchMonthToDateRed({
								status: 'succeed',
								showLoading: false,
								isFetching: false,
								hasFailed: true,
								data: json,
								...payload
							}));
						}

					)

			})
	}
}

export function callFetchMonthToDateRed ( payload ) {
	return {
		type: FETCH_MONTH_TO_DATE,
		payload: payload
	}
}

//////////////////////
// Route
//////////////////////

export function changeTheRoute ( newRoute, method ) {
		// newRoute, // the new route, can be relative or absolute
		// method, // can be push, go, goto, replace and so on
    console.log( 'CHANGING THE ROUTE --- ', newRoute, method)
    switch (method) {
        case 'push':
            browserHistory.push(newRoute);
            break;
        case 'replace':
            browserHistory.replace(newRoute);
            break;
		case 'goBack':
			browserHistory.goBack();
			break;
        default:
            console.log('the requested method is either not yet implemented or there is a typo in it.\n No worries, defaulting to push instead..')
            browserHistory.push(newRoute);
    }
}

//////////////////////
// Create New User
//////////////////////

export function createNewUser ( payload ) {

    console.log( 'Add user payload: ', payload);

    var statusErrorMessage = null;

    switch ( payload.status ){
		case 'cancelled':

			console.log( 'CANCEL USER CREATION --- ');
			browserHistory.push('/Dashboard/default');
			return function (dispatch) {
				dispatch(callCreateNewUser({
					status: 'cancelled'
				}));
			};
		case 'init':

			return function (dispatch){
                dispatch(callCreateNewUser())
            };
            break;
        case 'validation':

            console.log('Add user Form data: ', payload.formData);
            console.log('Add user Passweord strength: ', zxcvbn(payload.formData.password).score);
            var v = validateAddUserForm(payload.formData);
            console.log('Add user validation information: ', v);

            if (v.validated) {

                console.log('Add user form data was validated');
                return function (dispatch, getState) {
                    dispatch(callCreateNewUser({
                        status: 'validated',
                        validationErrors: v.messages
                    }));

					Sso.authorize().then(function (authorization) {

						console.log('AUTH', authorization);
						dispatch(callCreateNewUser({
							status: 'fetching'
						}));

                        browserHistory.push('/Dashboard/default');
                        dispatch(callFetchUsersListRed({
                            status: 'pendingUsers',
                            pendingUser: {
                                status: 'creating',
                                email: "Creating User",
                                username: payload.formData.userName,
                                role: payload.formData.permission
                            }
                        }));

                        return fetch(`/accounts/${getState().getAzureProviderRelationshipRed.rootAccountAlias}/relationships/azure/users/${payload.formData.userName}`,{ // or should it be: ${payload.formData.userName} ?
							"method": 'POST',
							"headers": {
								"Authorization": `Bearer ${authorization.token}`,
								"Accept": "application/json",
								"Content-Type": "application/json"
							},

							"body": JSON.stringify({
								"username" : payload.formData.userName,
								"password" : payload.formData.password,
								"role" : payload.formData.permission,
								"firstName" : payload.formData.firstName,
								"lastName" : payload.formData.lastName
							})
						}).then(response => {
                            console.log(response)

							console.log('Add user response from server: ', response);

							if(!response.ok){
                                console.log('Add user setting statusErrorMessage');

                            	switch (response.status) {
                                	case 408:
                                    	statusErrorMessage = `Your request to create a user for ${payload.formData.userName} in Azure was timed out. Please try again or create a support ticket.`
                                        break;
									default:
                                    	statusErrorMessage  = `Your request to create user ${payload.formData.userName} in Azure failed. Azure's response is: `;
								}
							}

							return response.json()
						}).then((json) => {

                            if ( statusErrorMessage ) {

                                console.log("Add user response failed response: ", json);

                                dispatch(callFetchUsersListRed({
                                    status: 'pendingUsers',
                                    pendingUser: {
                                        status: 'failed',
                                        email: "Error creating user",
                                        username: payload.formData.userName,
                                        role: payload.formData.permission,
                                        message: statusErrorMessage + json.message
                                    }
                                }));
                            } else {

                                console.log("Add user response successful response: ", json);

                                dispatch(callCreateNewUser({
                                    status: 'init'
                                }));

                                dispatch(callFetchUsersListRed({
                                    status: 'pendingUsers',
                                    pendingUser: {
                                        status: 'created',
                                        email: json.email,
                                        username: json.username,
                                        role: payload.formData.permission
                                    }
                                }));
                            }
						})
					})
                }

            } else {
                console.log('Add user form data is NOT valid.. ', v.messages);
                return function (dispatch) { // Roast notifications should be dispatched from here
                    dispatch(callCreateNewUser({
                        status: 'notValid',
						inputValidation: v
                    }))
                }
            }
            break;
        default:
            console.log('default here', payload);
    }
}

function validateAddUserForm( data ){
    function isEmpty(s){
        return (/\s/g.test(s));
    }
    function isAlphaNumeric(s){
        return (s.search(/^[a-zA-Z0-9-_]+$/) === 0)
    }
    var r = {
        validated: true,
        messages: []
    }
	if( isEmpty( data.firstName ) || !isAlphaNumeric(data.firstName)){
		r.validated = false;
		r.messages.push('First Name should not be left empty, contain whitespaces and must be composed of only alphanumeric characters plus hyphen and / or underscores')
	}
	if( isEmpty( data.lastName ) || !isAlphaNumeric(data.lastName)){
		r.validated = false;
		r.messages.push('Last Name should not be left empty, contain whitespaces and must be composed of only alphanumeric characters plus hyphen and / or underscores')
	}
    if ( isEmpty(data.userName) || !isAlphaNumeric(data.userName)) {
        r.validated = false;
        r.messages.push('The User Name should not be empty, contain whitespaces and must be composed of only alphanumeric characters plus hyphen and / or underscores');
    }
    let ps = zxcvbn(data.password).score;
    if ( isEmpty(data.password) || ps < 2){
        r.validated = false;
        r.messages.push(`Password field can not be left empty. also it can\'t be super weak. Your password strength score is ${ps}, you can make it stronger by making it longer or using special characters and a combination of letters, lower-case and upper-case alphabetical characters.`);
    }
    if ( data.passwordConfirm !== data.password ){
        r.validated = false;
        r.messages.push('Password confirmation contents field should be equal to the password field');
    }
    return r;
}

function convertFormToJson(formData){
    var o = {};
    var a = formData.serializeArray();
    $.each(a, function() {
        if (o[formData.name] !== undefined) {
            if (!o[formData.name].push) {
                o[formData.name] = [o[formData.name]];
            }
            o[formData.name].push(formData.value || '');
        } else {
            o[formData.name] = formData.value || '';
        }
    });
    return o;
}

export const callCreateNewUser = ( payload ) => ({
    type: CREATE_NEW_USER,
    payload
});

//////////////////////
// Get User List
//////////////////////

export function fetchUsersList ( payload ) {
    return function(dispatch, getState){

        dispatch(callFetchUsersListRed({
            status: 'init',
            isFetching: false,
            showLoading: true,
            loadingMessage: 'Initializing...',
            loadingMessage2: 'Please wait, this won\'t take long..',
            data: [],
            ...payload
        }));
        Sso.authorize().then(function (authorization) {

            dispatch(callFetchUsersListRed({
                    status: 'fetching',
                    showLoading: true,
                    loadingMessage: 'Loading...',
                    loadingMessage2: 'Getting the list of users...',
                    isFetching: true,
                    rootAccountAlias: authorization.rootAccountAlias,
                    bearerToken: authorization.token,
                    data: [],
                    ...payload
            }));

            return fetch(`/accounts/${getState().getAzureProviderRelationshipRed.rootAccountAlias}/relationships/azure/users`, {
                data: "json",
                method: 'GET',
                headers: {
                    Authorization: (`Bearer ${authorization.token}`)
                }
            }).then(response => {
                console.log('RESPONSE: ', response)
                if(!response.ok){//TODO: needs work
                    alert('Not 200, needs implementation (out of scope) <- according to the .status code react appropriately..');
                    dispatch(callFetchUsersListRed({
                        status: 'failed',
                        showLoading: false,
                        isFetching: false,
                        hasFailed: true,
                        rootAccountAlias: authorization.rootAccountAlias,
                        bearerToken: authorization.token,
                        ...payload
                    }));
                }
                return response.json()
            }).then(json => {/* json is the meat of the response that we will pass to the component as data prop */
                Role.isAccountAdmin(authorization.token).then(function (isAccountAdmin) {

                    dispatch(callFetchUsersListRed({
                        status: 'succeed',
                        showLoading: false,
                        isFetching: false,
                        hasFailed: true,
                        data: json,
                        isAccountAdmin: isAccountAdmin,
                        rootAccountAlias: authorization.rootAccountAlias,
                        bearerToken: authorization.token,
                        ...payload
                    }));
                })
            })
        })
    }
}

export function callFetchUsersListRed ( payload ){
	return{
		type: FETCH_USERS_LIST,
		payload: payload
	}
}

//////////////////////
// Provider Relationship
//////////////////////

export const toggleFSLoading = ( payload ) => ({
	type: TOGGLE_FS_LOADING,
	payload
});

export const toggleTacCheckbox = ( bool ) => {
	return {
		type: TOGGLE_TAC_CHECKBOX,
		bool
	}
};

export function tacSubmit ( ) {
	return function(dispatch, getState){
		if(getState().tacRed.isTacChecked){
			dispatch(toggleFSLoading({
				showLoadingFS: true,
				loadingFSText1: 'Please Wait',
				loadingFSText2: 'We are creating your Azure subscription'}));
			dispatch(fetchAzuProvRela({
				rootAccountAlias: (window.atlas.config().rootAccountAlias),
				bearerToken: (window.atlas.config().bearerToken),
				method: 'POST'})
			)
		}else{
			alert('You need to first accept the terms and conditions')
		}
	}
}

export const resetErrorMessage = () => ({
	type: RESET_ERROR_MESSAGE
});

export const getAzureProviderRelationship = (payload) => { // payload : accountAlias, token
	return {
		type: GET_AZURE_PROVIDER_RELATIONSHIP,
		payload
	}
};

export function redLaunch ( payload ) { // [redux_lunch] we wait for atlas etc. to be ready before moving on to our react/redux app because of the dependencies
	console.log('RedLaunch Action: ' + payload.currentAccountAlias)
	return function(dispatch){
		if(payload.isAtlasLaunched){
			dispatch(toggleFSLoading({showLoadingFS:true, loadingFSText1: 'Initializing.', loadingFSText2: 'Please wait while we fetch your user data...'}))
			dispatch(
				fetchAzuProvRela({rootAccountAlias: payload.currentAccountAlias, bearerToken: (payload.currentAccountAlias), method: 'GET'})
				)
		}
	}
}

export function fetchAzuProvRela(payload){
	return function(dispatch){
		dispatch(getAzureProviderRelationship(payload))

		Sso.authorize().then(function (authorization) {
			console.log('AUTH', authorization)

			return fetch(`/accounts/${payload.rootAccountAlias}/relationships/azure`,{
				data: "json",
				method: payload.method,
				headers: {
					Authorization: (`Bearer ${authorization.token}`)
				}
			})
			.then(response => {
				if(response.ok){
					console.log('Azure Relationship was created or already exist!');
					browserHistory.push('/DashBoard/default');
				}else if ( response.status === 404 ) { // <- this means the relationship was NOT found hence 4o4
                    console.log('No Azure relationship was found!');
                    Role.isAccountAdmin(atlas.config().bearerToken).then(function (isAccountAdmin) {
                        if (isAccountAdmin) {
                            console.log('USER IS AN ADMIN.')
                            browserHistory.push('/TermsAndConditions');
                        } else { //TODO: ./NonAdminUser
                            console.log('USER IS NOT AN ADMIN.')
                            browserHistory.push('/NonAdminUser');
                        }
                    });


					dispatch(toggleFSLoading({ showLoadingFS: false }))
				}else{
					console.log('ERROR:', response)
					alert('Something went wrong! We couldn\'t communicate with the right authority at the right server! Please try again later.')
				}
				console.log('Relationship request response: ', response)
				return response.json()
			})
			.then(json =>
				dispatch(toggleFSLoading({showLoadingFS: false}))
				)

		})
	}
}


export const receiveAzureProviderRelationship = (json) => {
	return {
		type: RECEIVE_AZURE_PROVIDER_RELATIONSHIP,
		json
	}
};


/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/